import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoTroendelagPrimaerBokmaalNegativPdf,
  LogoTroendelagPrimaerBokmaalNegativPng,
  LogoTroendelagPrimaerBokmaalNegativSvg,
  LogoTroendelagPrimaerBokmaalPositivPdf,
  LogoTroendelagPrimaerBokmaalPositivPng,
  LogoTroendelagPrimaerBokmaalPositivSvg,
  LogoTroendelagPrimaerBokmaalEngelskNegativPdf,
  LogoTroendelagPrimaerBokmaalEngelskNegativPng,
  LogoTroendelagPrimaerBokmaalEngelskNegativSvg,
  LogoTroendelagPrimaerBokmaalEngelskPositivPdf,
  LogoTroendelagPrimaerBokmaalEngelskPositivPng,
  LogoTroendelagPrimaerBokmaalEngelskPositivSvg,
  LogoTroendelagPrimaerNynorskNegativPdf,
  LogoTroendelagPrimaerNynorskNegativPng,
  LogoTroendelagPrimaerNynorskNegativSvg,
  LogoTroendelagPrimaerNynorskPositivPdf,
  LogoTroendelagPrimaerNynorskPositivPng,
  LogoTroendelagPrimaerNynorskPositivSvg,
  LogoTroendelagPrimaerNynorskEngelskNegativPdf,
  LogoTroendelagPrimaerNynorskEngelskNegativPng,
  LogoTroendelagPrimaerNynorskEngelskNegativSvg,
  LogoTroendelagPrimaerNynorskEngelskPositivPdf,
  LogoTroendelagPrimaerNynorskEngelskPositivPng,
  LogoTroendelagPrimaerNynorskEngelskPositivSvg,
  LogoTroendelagSekundaerBokmaalNegativPdf,
  LogoTroendelagSekundaerBokmaalNegativPng,
  LogoTroendelagSekundaerBokmaalNegativSvg,
  LogoTroendelagSekundaerBokmaalPositivPdf,
  LogoTroendelagSekundaerBokmaalPositivPng,
  LogoTroendelagSekundaerBokmaalPositivSvg,
  LogoTroendelagSekundaerBokmaalEngelskNegativPdf,
  LogoTroendelagSekundaerBokmaalEngelskNegativPng,
  LogoTroendelagSekundaerBokmaalEngelskNegativSvg,
  LogoTroendelagSekundaerBokmaalEngelskPositivPdf,
  LogoTroendelagSekundaerBokmaalEngelskPositivPng,
  LogoTroendelagSekundaerBokmaalEngelskPositivSvg,
  LogoTroendelagSekundaerNynorskNegativPdf,
  LogoTroendelagSekundaerNynorskNegativPng,
  LogoTroendelagSekundaerNynorskNegativSvg,
  LogoTroendelagSekundaerNynorskPositivPdf,
  LogoTroendelagSekundaerNynorskPositivPng,
  LogoTroendelagSekundaerNynorskPositivSvg,
  LogoTroendelagSekundaerNynorskEngelskNegativPdf,
  LogoTroendelagSekundaerNynorskEngelskNegativPng,
  LogoTroendelagSekundaerNynorskEngelskNegativSvg,
  LogoTroendelagSekundaerNynorskEngelskPositivPdf,
  LogoTroendelagSekundaerNynorskEngelskPositivPng,
  LogoTroendelagSekundaerNynorskEngelskPositivSvg,
  LogoTroendelagSentrertBokmaalNegativPdf,
  LogoTroendelagSentrertBokmaalNegativPng,
  LogoTroendelagSentrertBokmaalNegativSvg,
  LogoTroendelagSentrertBokmaalPositivPdf,
  LogoTroendelagSentrertBokmaalPositivPng,
  LogoTroendelagSentrertBokmaalPositivSvg,
  LogoTroendelagSentrertBokmaalEngelskNegativPdf,
  LogoTroendelagSentrertBokmaalEngelskNegativPng,
  LogoTroendelagSentrertBokmaalEngelskNegativSvg,
  LogoTroendelagSentrertBokmaalEngelskPositivPdf,
  LogoTroendelagSentrertBokmaalEngelskPositivPng,
  LogoTroendelagSentrertBokmaalEngelskPositivSvg,
  LogoTroendelagSentrertNynorskNegativPdf,
  LogoTroendelagSentrertNynorskNegativPng,
  LogoTroendelagSentrertNynorskNegativSvg,
  LogoTroendelagSentrertNynorskPositivPdf,
  LogoTroendelagSentrertNynorskPositivPng,
  LogoTroendelagSentrertNynorskPositivSvg,
  LogoTroendelagSentrertNynorskEngelskNegativPdf,
  LogoTroendelagSentrertNynorskEngelskNegativPng,
  LogoTroendelagSentrertNynorskEngelskNegativSvg,
  LogoTroendelagSentrertNynorskEngelskPositivPdf,
  LogoTroendelagSentrertNynorskEngelskPositivPng,
  LogoTroendelagSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Troendelag/exportTroendelag.js";

export default function TrøndelagPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Trøndelag"
          lead="Alle logoer for Trøndelag i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoTroendelagPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, bokmål"
                    text="Bokmål"
                    blackSvg={LogoTroendelagPrimaerBokmaalPositivSvg}
                    blackPng={LogoTroendelagPrimaerBokmaalPositivPng}
                    blackPdf={LogoTroendelagPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoTroendelagPrimaerBokmaalNegativSvg}
                    whitePng={LogoTroendelagPrimaerBokmaalNegativPng}
                    whitePdf={LogoTroendelagPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoTroendelagPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoTroendelagPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoTroendelagPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoTroendelagPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoTroendelagPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoTroendelagPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoTroendelagPrimaerNynorskPositivSvg}
                    blackPng={LogoTroendelagPrimaerNynorskPositivPng}
                    blackPdf={LogoTroendelagPrimaerNynorskPositivPdf}
                    whiteSvg={LogoTroendelagPrimaerNynorskNegativSvg}
                    whitePng={LogoTroendelagPrimaerNynorskNegativPng}
                    whitePdf={LogoTroendelagPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoTroendelagPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoTroendelagPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoTroendelagPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoTroendelagPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoTroendelagPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoTroendelagPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoTroendelagSekundaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, bokmål"
                    text="Bokmål"
                    blackSvg={LogoTroendelagSekundaerBokmaalPositivSvg}
                    blackPng={LogoTroendelagSekundaerBokmaalPositivPng}
                    blackPdf={LogoTroendelagSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoTroendelagSekundaerBokmaalNegativSvg}
                    whitePng={LogoTroendelagSekundaerBokmaalNegativPng}
                    whitePdf={LogoTroendelagSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagSekundaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoTroendelagSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoTroendelagSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoTroendelagSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoTroendelagSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoTroendelagSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoTroendelagSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagSekundaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoTroendelagSekundaerNynorskPositivSvg}
                    blackPng={LogoTroendelagSekundaerNynorskPositivPng}
                    blackPdf={LogoTroendelagSekundaerNynorskPositivPdf}
                    whiteSvg={LogoTroendelagSekundaerNynorskNegativSvg}
                    whitePng={LogoTroendelagSekundaerNynorskNegativPng}
                    whitePdf={LogoTroendelagSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagSekundaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoTroendelagSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoTroendelagSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoTroendelagSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoTroendelagSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoTroendelagSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoTroendelagSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoTroendelagSentrertBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, bokmål"
                    text="Bokmål"
                    blackSvg={LogoTroendelagSentrertBokmaalPositivSvg}
                    blackPng={LogoTroendelagSentrertBokmaalPositivPng}
                    blackPdf={LogoTroendelagSentrertBokmaalPositivPdf}
                    whiteSvg={LogoTroendelagSentrertBokmaalNegativSvg}
                    whitePng={LogoTroendelagSentrertBokmaalNegativPng}
                    whitePdf={LogoTroendelagSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagSentrertBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoTroendelagSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoTroendelagSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoTroendelagSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoTroendelagSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoTroendelagSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoTroendelagSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagSentrertNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoTroendelagSentrertNynorskPositivSvg}
                    blackPng={LogoTroendelagSentrertNynorskPositivPng}
                    blackPdf={LogoTroendelagSentrertNynorskPositivPdf}
                    whiteSvg={LogoTroendelagSentrertNynorskNegativSvg}
                    whitePng={LogoTroendelagSentrertNynorskNegativPng}
                    whitePdf={LogoTroendelagSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTroendelagSentrertNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Trøndelag, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoTroendelagSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoTroendelagSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoTroendelagSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoTroendelagSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoTroendelagSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoTroendelagSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
